<template lang="pug">
    div.expandCard
        table
            tr
                td {{ $t('fields.date') }}
                td {{ item.createdAt | formattedDate }}

            tr
                td {{ $t('fields.contactName') }}
                td {{ item.owner.fullName }}

            tr(v-if="item.program && item.program.startedAt")
                td {{ $t('fields.dateRange') }}
                td {{ item.program.startedAt | formattedDate }} - {{ item.program.endedAt | formattedDate }}

            tr
                td {{ $t('fields.contactEmail') }}
                td {{ item.owner.email }}

            tr
                td {{ $t('fields.contactPhone') }}
                td {{ item.owner.phone | phoneNumber }}

            tr
                td {{ $t('fields.status') }}
                td {{ item.isActive ? $t('fields.active') : $t('fields.inactive') }}

            tr
                td {{ $t('fields.userCapacity') }}
                td.capitalize {{`${item.countUsers} / ${item.maxUsers }`}}
</template>

<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';

    export default {
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            /**
             * Get title for business program
             * @param item
             * @returns {TranslateResult|VueI18n.TranslateResult|string|{custom: string, challenge: string}|{custom: string, challenge: string}}
             */
            getProgramTitle(item) {
                if (item.programTitle) {
                    return item.programTitle;
                }

                if (item.isCustomProgram) {
                    return this.$t('business.list.programTitle.custom');
                }

                if (item.isChallenge) {
                    return this.$t('business.list.programTitle.challenge');
                }

                return '';
            }
        }
    };
</script>
